import { getDirectionContract } from './board/definitions/get-direction.contract.js';
import { getProductsContract } from './board/definitions/get-products.contract.js';
import { getStageSheetsContract } from './board/definitions/get-stage-sheets.contract.js';
import { listProductBindingsContract } from './board/definitions/list-product-bindings.contract.js';
import { updateProductBindingContract } from './board/definitions/update-product-binding.contract.js';
import { listBoardBindingsContract } from './board/definitions/list-board-bindings.contract.js';
import { updateBoardBindingContract } from './board/definitions/update-board-binding.contract.js';
import { changePasswordContract } from './auth/definitions/change-password.contract.js';
import { getMeContract } from './auth/definitions/get-me.contract.js';
import { loginUserContract } from './auth/definitions/login-user.contract.js';
import { logoutUserContract } from './auth/definitions/logout-user.contract.js';
import { refreshTokenContract } from './auth/definitions/refresh-token.contract.js';
import { getHealthContract } from './health/definitions/get-health.contract.js';
import { createKpiContract } from './kpis/definitions/create-kpi.contract.js';
import { deleteKpiContract } from './kpis/definitions/delete-kpi.contract.js';
import { getKpiContract } from './kpis/definitions/get-kpi.contract.js';
import { listKpisContract } from './kpis/definitions/list-kpis.contract.js';
import { reorderKpisContract } from './kpis/definitions/reorder-kpis.contract.js';
import { updateKpiContract } from './kpis/definitions/update-kpi.contract.js';
import { getSteeringReportContract } from './reports/definitions/get-steering-report.contract.js';
import { createTargetContract } from './targets/definitions/create-target.contract.js';
import { getTargetContract } from './targets/definitions/get-target.contract.js';
import { listTargetsContract } from './targets/definitions/list-targets.contract.js';
import { updateTargetContract } from './targets/definitions/update-target.contract.js';
import { getTrackerGridContract } from './tracker/definitions/get-tracker-grid.contract.js';
import { saveTrackerValuesContract } from './tracker/definitions/save-tracker-values.contract.js';
import { createUserContract } from './users/definitions/create-user.contract.js';
import { getUserContract } from './users/definitions/get-user.contract.js';
import { listUsersContract } from './users/definitions/list-users.contract.js';
import { resetUserPasswordContract } from './users/definitions/reset-user-password.contract.js';
import { revokeUserSessionsContract } from './users/definitions/revoke-user-sessions.contract.js';
import { updateUserContract } from './users/definitions/update-user.contract.js';
import { addWeekContract } from './weeks/definitions/add-week.contract.js';
import { listWeeksContract } from './weeks/definitions/list-weeks.contract.js';
// Every zod schema, in one place, so `chery-contracts/schemas` and this entry point can never drift.
export * from './schemas.js';
export * from './auth/definitions/index.js';
export * from './board/definitions/index.js';
export * from './health/definitions/index.js';
export * from './kpis/definitions/index.js';
export * from './reports/definitions/index.js';
export * from './targets/definitions/index.js';
export * from './tracker/definitions/index.js';
export * from './users/definitions/index.js';
export * from './weeks/definitions/index.js';
/**
 * The single aggregate contract. The service implements it with `@Implement(cheryContract.<area>.<op>)` and the
 * web app consumes it through `OpenAPILink(cheryContract, …)`. Areas from plan §5 join phase by phase
 * (users, kpis and weeks since Phase 1; tracker since Phase 2; targets since Phase 3; reports since Phase 4; board since Phase 5; board products since Phase 8). Within an area, static
 * paths are declared before their `{id}` siblings.
 */
export const cheryContract = {
    auth: {
        login: loginUserContract,
        refresh: refreshTokenContract,
        logout: logoutUserContract,
        me: getMeContract,
        changePassword: changePasswordContract,
    },
    users: {
        list: listUsersContract,
        create: createUserContract,
        get: getUserContract,
        update: updateUserContract,
        resetPassword: resetUserPasswordContract,
        revokeSessions: revokeUserSessionsContract,
    },
    kpis: {
        list: listKpisContract,
        create: createKpiContract,
        reorder: reorderKpisContract,
        get: getKpiContract,
        update: updateKpiContract,
        delete: deleteKpiContract,
    },
    weeks: {
        list: listWeeksContract,
        add: addWeekContract,
    },
    tracker: {
        grid: getTrackerGridContract,
        saveValues: saveTrackerValuesContract,
    },
    targets: {
        list: listTargetsContract,
        create: createTargetContract,
        get: getTargetContract,
        update: updateTargetContract,
    },
    reports: {
        steering: getSteeringReportContract,
    },
    board: {
        direction: getDirectionContract,
        bindings: {
            list: listBoardBindingsContract,
            update: updateBoardBindingContract,
        },
        stageSheets: getStageSheetsContract,
        products: getProductsContract,
        productBindings: {
            list: listProductBindingsContract,
            update: updateProductBindingContract,
        },
    },
    health: {
        get: getHealthContract,
    },
};
//# sourceMappingURL=index.js.map